//Reference: EN121

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class ProfessionalInformation extends Mappeable {

    fileCvEsName: string;
    fileCvEnName: string;
    mobilityFunctional: boolean;
    mobilityGeographic: boolean;
    txtExperience: string;

    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            fileCvEnName: this.fileCvEnName,
            fileCvEsName: this.fileCvEsName,
            mobilityFunctional: this.mobilityFunctional,
            mobilityGeographic: this.mobilityGeographic,
            txtExperience: this.txtExperience,
        }
    }

    transformSpecialties(specialties) {
        let formatSpecialty = []
        _.forEach(specialties, (specialty) => {
            formatSpecialty.push({ typeSpecialityFk: specialty })
        })
        return formatSpecialty;
    }


}